
export default function(ctx: any) {
    if((/true/i).test(ctx.env.lockEnabled)){

        if (ctx.route.path === '/unlock' || ctx.$passwordProtect.isAuthorised()) {
            return;
        }

        return ctx.redirect('/unlock');
    }

    return;
}
